var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data color_bg_3"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"no-data_img"}),_c('div',{staticClass:"no-data_content color_text_2"},[_vm._v("暂无待领取福利")])])])
}]

export { render, staticRenderFns }